import React from 'react';
import PropTypes from 'prop-types';

import {
  ActionContainer,
  ActionLink,
  ActionTitle,
} from '../../shared/styles';
import { Dot } from '../../companies/companies-components/styles';
import CompaniesContext from '../../companies/companies-components/context';

export default function Actions({ company }) {
  const { dispatch } = React.useContext(CompaniesContext);

  const showModal = type => e => {
    e && e.preventDefault();

    dispatch({ type, payload: company });
  };

  return (
    <ActionContainer>
      <ActionTitle>Tools</ActionTitle>
      <ActionLink href="#" onClick={showModal('editCompany')}>Edit Company</ActionLink>
      <ActionLink href="#" onClick={showModal('brandCompany')}>Brand Company</ActionLink>
      <ActionLink href="#" onClick={showModal('ctaCompany')}>
        Edit Company CTA
        { company.cta && <Dot /> }
      </ActionLink>
    </ActionContainer>
  );
}

Actions.propTypes = {
  company: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    administratorEmail: PropTypes.string,
    websiteUrl: PropTypes.string,
    cta: PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      message: PropTypes.string,
      text: PropTypes.string,
      url: PropTypes.string,
    }),
    members: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })),
  }).isRequired,
};
